import axiosPost from "../axiosPost";

export const migraTipoDePasoIns = async (
    { migraTipoDePasoCod, migraTipoDePasoNombre },
    credentials
) => {
    const body = {
        service: "MigraTipoDePasoIns",
        params: {
            merchantId: credentials.merchantId,
            migraTipoDePasoCod,
            migraTipoDePasoNombre,
        },
    };

    return await axiosPost(body, credentials);
};
